<template>
  <div>
    <div class="faq_content_wrapper">
      <!-- HEADER SECTION -->
      <div class="header_section">
        <div class="header_texts">
          <div>
            <h1 class="page_title">{{ ui.title }}</h1>
            <p class="section_desc">
              {{ ui.subtitle }}
            </p>
          </div>
          <div class="role_badge">
            <span class="role_label">{{ ui.current_role }}</span>
            <span class="role_value">{{ this.currentRole }}</span>
          </div>
        </div>
      </div>

      <!-- TABS -->
      <div class="tabs_container">
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_ios_ipados' }"
          @click="changeToIOSIPADOS"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9"></path>
              <path
                d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
              ></path>
            </svg>
          </span>
          {{ ui.tabs.ios }}
        </button>
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_macos' }"
          @click="changeToMacOS"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
          </span>
          {{ ui.tabs.macos }}
        </button>
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_abm' }"
          @click="changeToABM"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
              ></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </span>
          {{ ui.tabs.abm }}
        </button>
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_powerpoint' }"
          @click="changeToPowerpoint"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M8 21h8"></path>
              <path d="M12 17v4"></path>
              <path d="M7 8h2l2 3-2 3H7V8z"></path>
              <path d="M15 8h2l2 3-2 3h-2V8z"></path>
            </svg>
          </span>
          {{ ui.tabs.powerpoint }}
        </button>
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_tutorialvideo' }"
          @click="changeToTutorialVideo"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"
              ></path>
              <polygon
                points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
              ></polygon>
            </svg>
          </span>
          {{ ui.tabs.tutorial }}
        </button>
        <button
          class="tab_btn"
          :class="{ active: selected_cms_page === 'faq_updates' }"
          @click="changeToUpdates"
        >
          <span class="tab_icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
              ></path>
              <path
                d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
              ></path>
            </svg>
          </span>
          {{ ui.tabs.updates }}
        </button>
      </div>

      <!-- MAIN CARD (ACCORDION) -->
      <div class="premium_card">
        <!-- UPDATES HISTORY LIST -->
        <div v-if="selected_cms_page === 'faq_updates'" class="updates_list">
          <div class="update_card_item" v-for="(log, i) in changelog" :key="i">
            <div class="update_header">
              <div class="version_badge">v{{ log.version }}</div>
              <span class="update_date">{{ log.date }}</span>
            </div>
            <ul class="update_points">
              <li v-for="(u, j) in log.updates" :key="j">
                <strong>{{ u.title }}</strong
                >: {{ u.description }}
              </li>
            </ul>
          </div>
        </div>

        <!-- POWERPOINT SLIDE SECTION -->
        <div
          v-else-if="selected_cms_page === 'faq_powerpoint'"
          class="powerpoint_section"
        >
          <div class="powerpoint_header">
            <h3>{{ ui.powerpoint_title }}</h3>
            <p>{{ ui.powerpoint_subtitle }}</p>
          </div>

          <!-- Dropdown Selector -->
          <div class="slide_selector_wrapper">
            <label class="selector_label">{{ ui.select_presentation }}</label>
            <div class="custom_select">
              <select v-model="selectedSlide" class="slide_dropdown">
                <option value="" disabled>{{ ui.choose_slide }}</option>
                <option
                  v-for="(slide, idx) in powerpointSlides"
                  :key="idx"
                  :value="slide.id"
                >
                  {{ slide.name }}
                </option>
              </select>
              <span class="dropdown_arrow">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </span>
            </div>
          </div>

          <!-- Slide Preview Area -->
          <div v-if="selectedSlide" class="slide_preview_area">
            <div class="slide_preview_header">
              <span class="preview_title">{{ getSelectedSlideName() }}</span>
            </div>
            <div class="slide_preview_content">
              <TutorialSlideshow :images="slideshowImages[selectedSlide]" />
            </div>
          </div>

          <!-- Empty State -->
          <div v-else class="slide_empty_state">
            <div class="empty_icon">
              <svg
                width="56"
                height="56"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M8 21h8"></path>
                <path d="M12 17v4"></path>
              </svg>
            </div>
            <p>{{ ui.select_slide_prompt }}</p>
          </div>
        </div>

        <div class="faq_list" v-else>
          <!-- Introduction if any -->
          <div
            v-if="
              lang.introduction_detail && lang.introduction_detail.length > 0
            "
            class="faq_intro"
          >
            <h3>{{ lang.introduction }}</h3>
            <p v-for="(intro, i) in lang.introduction_detail" :key="i">
              {{ intro }}
            </p>
          </div>

          <!-- Important Notes Section (ABM) -->
          <div
            v-if="lang.important_notes && lang.important_notes.length > 0"
            class="important_notes_section"
          >
            <div class="important_notes_header">
              <span class="important_notes_icon">⚠️</span>
              <span class="important_notes_title">{{
                ui.important_notes_header
              }}</span>
            </div>
            <div class="important_notes_grid">
              <div
                v-for="(note, idx) in lang.important_notes"
                :key="idx"
                class="important_note_card"
                :class="note.type"
              >
                <div class="note_header">
                  <span class="note_icon">{{ note.icon }}</span>
                  <span class="note_title">{{ note.title }}</span>
                </div>
                <p class="note_message" v-html="note.message"></p>
              </div>
            </div>
          </div>

          <!-- FAQ Items -->
          <div
            v-for="index in arrayLength"
            :key="index"
            class="accordion_item"
            :class="{ open: expandedIndex === index }"
          >
            <div class="accordion_header" @click="toggleAccordion(index)">
              <div class="question_text">
                <span class="q_number">{{ index }}.</span>
                <span
                  v-if="hasImgTag(lang.question[index - 1])"
                  v-html="lang.question[index - 1]"
                ></span>
                <span v-else>{{ lang.question[index - 1] }}</span>
              </div>
              <div class="accordion_icon">
                <!-- Chevron Down -->
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>

            <transition name="slide-fade">
              <div v-if="expandedIndex === index" class="accordion_body">
                <div class="answer_content">
                  <!-- Special Slideshow Condition -->
                  <div
                    v-if="
                      lang.question[index - 1] === 'ABM Tutorial Slideshow' ||
                      lang.question[index - 1] === 'ABM Slaid Tutorial' ||
                      lang.question[index - 1] === 'สไลด์แนะนำ ABM' ||
                      lang.question[index - 1] === 'Scenes of ABM Tutorial'
                    "
                  >
                    <TutorialSlideshow :images="abmTutorialImages" />
                  </div>

                  <div
                    v-else
                    v-for="(explanation, idx2) in lang.explaination[index - 1]"
                    :key="idx2"
                  >
                    <div
                      v-if="hasImgTag(explanation)"
                      v-html="explanation"
                      class="answer_img_wrapper"
                    ></div>
                    <p v-else>{{ explanation }}</p>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TutorialSlideshow from "./TutorialSlideshow.vue";
import { getCmsDetails } from "@/api/cms.js";
import changelogData from "@/data/changelog.json";

export default {
  components: {
    TutorialSlideshow,
  },
  data() {
    return {
      title: "Frequently Asked Questions [iOS/iPadOS MDM] (FAQ)", // Kept for legacy compatibility if needed
      arrayLength: 0,
      lang: {
        title: "",
        second_title: "",
        content: "",
        introduction: "",
        introduction_detail: [],
        important_notes: [],
        question: [],
        explaination: [],
      },
      data: {},
      selected_faq_page: "/faq-ios-ipados.json",
      selected_cms_page: "faq_ios_ipados",
      currentRole: localStorage.role,
      langc: localStorage.locale?.toLowerCase() || "eng",
      expandedIndex: null, // Tracks which accordion item is open
      changelog: changelogData,
      lang_ui: {
        eng: {
          title: "Frequently Asked Questions",
          subtitle:
            "Find answers to common questions about managing your devices.",
          current_role: "Current Role:",
          important_notes_header:
            "Important Notes - Please Read Before Proceeding",
          powerpoint_title: "PowerPoint Presentations",
          powerpoint_subtitle:
            "Select a presentation to view training slides and guides.",
          select_presentation: "Select a Presentation:",
          choose_slide: "-- Choose a slide deck --",
          slide_coming_soon: "Slideshow Coming Soon",
          slide_coming_soon_sub:
            "This presentation is being prepared and will be available shortly.",
          select_slide_prompt:
            "Please select a presentation from the dropdown above to view.",
          tabs: {
            ios: "iOS/iPadOS",
            macos: "macOS",
            abm: "ABM",
            powerpoint: "PowerPoint Slide",
            tutorial: "Tutorial Video",
            updates: "Updates History",
          },
        },
        bm: {
          title: "Soalan Lazim",
          subtitle:
            "Cari jawapan kepada soalan lazim mengenai pengurusan peranti anda.",
          current_role: "Peranan Semasa:",
          important_notes_header: "Nota Penting - Sila Baca Sebelum Meneruskan",
          powerpoint_title: "Pembentangan PowerPoint",
          powerpoint_subtitle:
            "Pilih pembentangan untuk melihat slaid latihan dan panduan.",
          select_presentation: "Pilih Pembentangan:",
          choose_slide: "-- Pilih set slaid --",
          slide_coming_soon: "Tayangan Slaid Akan Datang",
          slide_coming_soon_sub:
            "Pembentangan ini sedang disediakan dan akan tersedia tidak lama lagi.",
          select_slide_prompt:
            "Sila pilih pembentangan dari dropdown di atas untuk melihat.",
          tabs: {
            ios: "iOS/iPadOS",
            macos: "macOS",
            abm: "ABM",
            powerpoint: "Slaid PowerPoint",
            tutorial: "Video Tutorial",
            updates: "Sejarah Kemas Kini",
          },
        },
        th: {
          title: "คำถามที่พบบ่อย",
          subtitle:
            "ค้นหาคำตอบสำหรับคำถามทั่วไปเกี่ยวกับการจัดการอุปกรณ์ของคุณ",
          current_role: "บทบาทปัจจุบัน:",
          important_notes_header: "หมายเหตุสำคัญ - กรุณาอ่านก่อนดำเนินการต่อ",
          powerpoint_title: "การนำเสนอ PowerPoint",
          powerpoint_subtitle: "เลือกการนำเสนอเพื่อดูสไลด์การฝึกอบรมและคู่มือ",
          select_presentation: "เลือกการนำเสนอ:",
          choose_slide: "-- เลือกชุดสไลด์ --",
          slide_coming_soon: "สไลด์โชว์กำลังจะมา",
          slide_coming_soon_sub:
            "การนำเสนอนี้กำลังเตรียมการและจะพร้อมใช้งานในเร็วๆ นี้",
          select_slide_prompt: "กรุณาเลือกการนำเสนอจากดรอปดาวน์ด้านบนเพื่อดู",
          tabs: {
            ios: "iOS/iPadOS",
            macos: "macOS",
            abm: "ABM",
            powerpoint: "สไลด์ PowerPoint",
            tutorial: "วิดีโอแนะนำ",
            updates: "ประวัติการอัปเดต",
          },
        },
      },
      abmTutorialImages: [
        "/ABM_faq/ABM-tutorial-pg1.png",
        "/ABM_faq/ABM-tutorial-pg2.png",
        "/ABM_faq/ABM-tutorial-pg3.png",
        "/ABM_faq/ABM-tutorial-pg4.png",
        "/ABM_faq/ABM-tutorial-pg5.png",
        "/ABM_faq/ABM-tutorial-pg6.png",
        "/ABM_faq/ABM-tutorial-pg7.png",
        "/ABM_faq/ABM-tutorial-pg8.png",
      ],
      selectedSlide: "",
      powerpointSlides: [],
      slideshowImages: {},
    };
  },
  mounted() {
    this.initializePageLanguage();
    this.loadPowerpointData();
  },
  computed: {
    ui() {
      // Return UI strings based on current language, fallback to 'eng'
      return this.lang_ui[this.langc] || this.lang_ui["eng"];
    },
  },
  methods: {
    toggleAccordion(index) {
      if (this.expandedIndex === index) {
        this.expandedIndex = null; // Collapse if already open
      } else {
        this.expandedIndex = index; // Expand clicked
      }
    },
    async loadPowerpointData() {
      try {
        const response = await fetch("/faq-powerpoint.json");
        const data = await response.json();
        this.powerpointSlides = data.slides || [];
        this.slideshowImages = data.images || {};
      } catch (error) {
        console.error("Failed to load PowerPoint data:", error);
      }
    },
    hasImgTag(content) {
      const imgTagPattern = /<\/?([a-z][a-z0-9]*)[^>]{0,200}>/gi;
      return imgTagPattern.test(content);
    },
    async initializePageLanguage() {
      const cmsDataString = await getCmsDetails("faq_ios_ipados", this.langc);

      if (cmsDataString) {
        const cmsContent = JSON.parse(cmsDataString);
        this.lang = cmsContent;
        this.arrayLength = cmsContent.question ? cmsContent.question.length : 0;
      } else {
        try {
          const response = await fetch(this.selected_faq_page);
          const data = await response.json();
          this.data = data;
          const targetLang = this.langc.toUpperCase();
          this.lang =
            this.data[targetLang] ||
            this.data["ENG"] ||
            Object.values(this.data)[0];
          this.arrayLength =
            this.lang && this.lang.question ? this.lang.question.length : 0;
        } catch (error) {
          console.error("Failed to load fallback JSON content:", error);
        }
      }
    },

    changeToUpdates() {
      this.selected_cms_page = "faq_updates";
      this.expandedIndex = null;
    },
    changeToTutorialVideo() {
      this.selected_faq_page = "/faq-tutorialvideo.json";
      this.selected_cms_page = "faq_tutorialvideo";
      this.refreshContent();
    },
    changeToMacOS() {
      this.selected_faq_page = "/faq-macos.json";
      this.selected_cms_page = "faq_macos";
      this.refreshContent();
    },
    changeToIOSIPADOS() {
      this.selected_faq_page = "/faq-ios-ipados.json";
      this.selected_cms_page = "faq_ios_ipados";
      this.refreshContent();
    },
    changeToABM() {
      this.selected_faq_page = "/faq-abm.json";
      this.selected_cms_page = "faq_abm";
      this.refreshContent();
    },
    changeToPowerpoint() {
      this.selected_cms_page = "faq_powerpoint";
      this.expandedIndex = null;
      this.selectedSlide = "";
    },
    getSelectedSlideName() {
      const slide = this.powerpointSlides.find(
        (s) => s.id === this.selectedSlide,
      );
      return slide ? slide.name : "";
    },
    refreshContent() {
      this.langchange(
        this.langc === "eng"
          ? "ENG"
          : this.langc === "bm"
          ? "BM"
          : this.langc === "th"
          ? "TH"
          : "ENG",
      );
      this.expandedIndex = null; // Reset accordion on tab change
    },
    async langchange(picker) {
      if (this.selected_cms_page === "faq_updates") return;

      if (picker === "eng" || picker === "bm" || picker === "th") {
        this.langc = picker.toLowerCase();
      } else {
        this.langc =
          picker === "ENG"
            ? "eng"
            : picker === "BM"
            ? "bm"
            : picker === "TH"
            ? "th"
            : picker === "english"
            ? "eng"
            : picker === "bahasa"
            ? "bm"
            : picker === "thai"
            ? "th"
            : picker.toLowerCase();
      }

      const cmsDataString = await getCmsDetails(
        this.selected_cms_page,
        this.langc,
      );

      if (cmsDataString) {
        const cmsContent = JSON.parse(cmsDataString);
        this.lang = cmsContent;
        this.arrayLength = cmsContent.question ? cmsContent.question.length : 0;
      } else {
        const response = await fetch(this.selected_faq_page);
        const data = await response.json();
        this.data = data;
        const targetLang = this.langc.toUpperCase();
        this.lang =
          this.data[targetLang] ||
          this.data["ENG"] ||
          Object.values(this.data)[0];
        this.arrayLength =
          this.lang && this.lang.question ? this.lang.question.length : 0;
      }
    },
  },
};
</script>

<style scoped>
/* PAGE LAYOUT */
.faq_content_wrapper {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.header_section {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-sm);
}

.header_texts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.page_title {
  font-family: "Century Gothic Bold";
  font-size: 28px;
  color: var(--text-main);
  margin: 0 0 8px 0;
}

.section_desc {
  font-family: "Century Gothic";
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
}

.role_badge {
  background-color: var(--surface-color);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 14px;
  display: flex;
  gap: 8px;
  box-shadow: var(--shadow-sm);
  align-items: center;
}

.role_label {
  color: var(--text-secondary);
  margin-right: 4px;
}

.role_value {
  font-family: "Century Gothic Bold";
  color: var(--text-main);
}

/* TABS */
.tabs_container {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.tab_btn {
  padding: 10px 24px;
  border-radius: 30px;
  border: 1px solid transparent;
  background-color: white;
  color: var(--text-secondary);
  font-family: "Century Gothic Bold";
  font-size: 14px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab_icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab_btn:hover {
  background-color: #f9fafb;
}

.tab_btn.active {
  background-color: var(--primary-color);
  color: var(--text-main);
  border-color: var(--primary-color);
}

/* CARD & LIST */
.premium_card {
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 24px;
  min-height: 400px;
}

.faq_intro {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.faq_intro h3 {
  font-family: "Century Gothic Bold";
  font-size: 18px;
  margin-bottom: 8px;
}

/* IMPORTANT NOTES SECTION */
.important_notes_section {
  margin-bottom: 28px;
  padding: 20px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border-radius: 16px;
  border: 2px solid #f59e0b;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
  animation: pulse-border 2s ease-in-out infinite;
}

@keyframes pulse-border {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
  }
  50% {
    box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
  }
}

.important_notes_header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(245, 158, 11, 0.3);
}

.important_notes_icon {
  font-size: 28px;
  animation: shake 0.5s ease-in-out infinite;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
  }
}

.important_notes_title {
  font-family: "Century Gothic Bold";
  font-size: 18px;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.important_notes_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.important_note_card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  border-left: 5px solid;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.important_note_card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.important_note_card.critical {
  border-left-color: #dc2626;
  background: linear-gradient(135deg, #ffffff 0%, #fef2f2 100%);
}

.important_note_card.warning {
  border-left-color: #f59e0b;
  background: linear-gradient(135deg, #ffffff 0%, #fffbeb 100%);
}

.note_header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.note_icon {
  font-size: 24px;
}

.note_title {
  font-family: "Century Gothic Bold";
  font-size: 15px;
  color: #1f2937;
}

.important_note_card.critical .note_title {
  color: #dc2626;
}

.important_note_card.warning .note_title {
  color: #b45309;
}

.note_message {
  font-family: "Century Gothic";
  font-size: 14px;
  line-height: 1.6;
  color: #4b5563;
  margin: 0;
}

/* POWERPOINT SECTION STYLES */
.powerpoint_section {
  padding: 16px 0;
}

.powerpoint_header {
  text-align: left;
  margin-bottom: 16px;
}

.powerpoint_header h3 {
  font-family: "Century Gothic Bold";
  font-size: 18px;
  color: var(--text-main);
  margin: 0 0 4px 0;
}

.powerpoint_header p {
  font-family: "Century Gothic";
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

.slide_selector_wrapper {
  max-width: 350px;
  margin: 0 0 24px 0;
}

.selector_label {
  font-family: "Century Gothic Bold";
  font-size: 13px;
  color: var(--text-main);
  display: block;
  margin-bottom: 6px;
}

.custom_select {
  position: relative;
}

.slide_dropdown {
  width: 100%;
  padding: 10px 40px 10px 14px;
  font-family: "Century Gothic";
  font-size: 14px;
  color: var(--text-main);
  background-color: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  appearance: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.slide_dropdown:hover {
  border-color: var(--primary-color);
}

.slide_dropdown:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(255, 214, 0, 0.3);
}

.dropdown_arrow {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  pointer-events: none;
}

.slide_preview_area {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 2px solid #fcd34d;
  border-radius: 16px;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide_preview_header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.8);
  border-bottom: 1px solid rgba(252, 211, 77, 0.4);
}

.preview_title {
  font-family: "Century Gothic Bold";
  font-size: 15px;
  color: #92400e;
}

.slide_preview_content {
  padding: 16px;
}

.coming_soon_text {
  font-family: "Century Gothic Bold";
  font-size: 20px;
  color: #92400e;
  margin: 0 0 8px 0;
}

.coming_soon_sub {
  font-family: "Century Gothic";
  font-size: 14px;
  color: #b45309;
  margin: 0;
}

.slide_empty_state {
  text-align: center;
  padding: 80px 20px;
  background: #f9fafb;
  border-radius: 16px;
  border: 2px dashed #e5e7eb;
}

.empty_icon {
  font-size: 56px;
  margin-bottom: 16px;
}

.slide_empty_state p {
  font-family: "Century Gothic";
  font-size: 15px;
  color: var(--text-secondary);
  margin: 0;
}

/* ACCORDION STYLES */
.accordion_item {
  border-bottom: 1px solid #f3f4f6;
}

.accordion_item:last-child {
  border-bottom: none;
}

.accordion_header {
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 12px;
}

.accordion_header:hover {
  background-color: #f9fafb;
}

.question_text {
  font-family: "Century Gothic Bold";
  font-size: 16px;
  color: var(--text-main);
  line-height: 1.5;
  flex: 1;
  padding-right: 16px;
}

.q_number {
  color: var(--primary-color);
  margin-right: 8px;
}

.accordion_icon {
  color: var(--text-secondary);
  transition: transform 0.3s ease;
  padding-top: 2px;
}

.accordion_item.open .accordion_icon {
  transform: rotate(180deg);
  color: var(--text-main);
}

.accordion_body {
  overflow: hidden;
}

.answer_content {
  padding: 0 24px 24px 48px; /* Indent to align with text */
  font-family: "Century Gothic";
  color: #4b5563;
  line-height: 1.6;
}

.answer_content p {
  margin-bottom: 12px;
}

.answer_content p:last-child {
  margin-bottom: 0;
}

.answer_img_wrapper :deep(img) {
  max-width: 100%;
  border-radius: 8px;
  margin-top: 8px;
  border: 1px solid #e5e7eb;
  height: auto; /* Ensure aspect ratio is preserved */
  display: block; /* Prevent inline spacing issues */
}

/* TRANSITION ANIMATIONS */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  max-height: 500px; /* Arbitrary large height */
  opacity: 1;
}

.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
  padding-bottom: 0;
}

/* UPDATES HISTORY STYLES */
.updates_list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.update_card_item {
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 24px;
}
.update_card_item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.update_header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.version_badge {
  background-color: #000;
  color: #ffd600;
  padding: 4px 10px;
  border-radius: 6px;
  font-family: "Century Gothic Bold";
  font-size: 14px;
}

.update_date {
  color: var(--text-secondary);
  font-size: 13px;
}

.update_points {
  list-style: none;
  padding: 0;
  margin: 0;
}

.update_points li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-main);
  position: relative;
  padding-left: 18px;
}

.update_points li::before {
  content: "•";
  color: var(--primary-color);
  position: absolute;
  left: 0;
  font-size: 18px;
  line-height: 1;
  top: 1px;
}

/* MOBILE RESPONSIVE STYLES */
@media (max-width: 768px) {
  .faq_content_wrapper {
    padding: 0 16px;
  }

  .header_section {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
  }

  .header_texts {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .page_title {
    font-size: 22px;
    line-height: 1.3;
  }

  .section_desc {
    font-size: 14px;
  }

  .role_badge {
    padding: 6px 12px;
    font-size: 12px;
    align-self: flex-start;
  }

  /* Tabs - Horizontal Scroll on Mobile */
  .tabs_container {
    gap: 8px;
    margin-bottom: 16px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
    /* Hide scrollbar for cleaner look */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }

  .tabs_container::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .tab_btn {
    padding: 8px 16px;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* Card Adjustments */
  .premium_card {
    padding: 16px;
    border-radius: 16px;
    min-height: 300px;
  }

  .faq_intro {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  .faq_intro h3 {
    font-size: 16px;
  }

  /* Important Notes Mobile */
  .important_notes_section {
    padding: 16px;
    margin-bottom: 20px;
  }

  .important_notes_header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .important_notes_icon {
    font-size: 24px;
  }

  .important_notes_title {
    font-size: 14px;
  }

  .important_notes_grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .important_note_card {
    padding: 16px;
  }

  .note_icon {
    font-size: 20px;
  }

  .note_title {
    font-size: 14px;
  }

  .note_message {
    font-size: 13px;
  }

  /* PowerPoint Mobile */
  .powerpoint_icon {
    font-size: 36px;
  }

  .powerpoint_header h3 {
    font-size: 20px;
  }

  .slide_selector_wrapper {
    max-width: 100%;
  }

  .slide_dropdown {
    font-size: 14px;
    padding: 12px 40px 12px 14px;
  }

  .slide_preview_content {
    padding: 40px 16px;
  }

  .coming_soon_text {
    font-size: 18px;
  }

  .slide_empty_state {
    padding: 50px 16px;
  }

  .empty_icon {
    font-size: 40px;
  }

  /* Accordion */
  .accordion_header {
    padding: 16px 12px;
  }

  .question_text {
    font-size: 15px;
    line-height: 1.4;
    padding-right: 12px;
  }

  .q_number {
    margin-right: 6px;
  }

  .accordion_icon svg {
    width: 20px;
    height: 20px;
  }

  .answer_content {
    padding: 0 12px 16px 32px;
    font-size: 14px;
    line-height: 1.5;
  }

  .answer_content p {
    margin-bottom: 10px;
  }

  .answer_img_wrapper img {
    border-radius: 6px;
  }

  /* Updates History */
  .updates_list {
    gap: 16px;
  }

  .update_card_item {
    padding-bottom: 16px;
  }

  .update_header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .version_badge {
    padding: 3px 8px;
    font-size: 12px;
  }

  .update_date {
    font-size: 12px;
  }

  .update_points li {
    font-size: 13px;
    padding-left: 16px;
    margin-bottom: 6px;
  }

  .update_points li::before {
    font-size: 16px;
  }
}

/* EXTRA SMALL MOBILE (max 480px) */
@media (max-width: 480px) {
  .faq_content_wrapper {
    padding: 0 12px;
  }

  .page_title {
    font-size: 20px;
  }

  .section_desc {
    font-size: 13px;
  }

  .premium_card {
    padding: 12px;
  }

  .question_text {
    font-size: 14px;
  }

  .answer_content {
    padding: 0 8px 12px 28px;
    font-size: 13px;
  }

  .tab_btn {
    padding: 7px 14px;
    font-size: 12px;
  }
}
</style>
